import { getData, postData, putData, deleteData } from '../services/apiService';
import { User, CreateUserType } from '../types/User';

// Get all users
export const getUsers = async (): Promise<User[] | null> => {
  try {
    const response = await getData('/users', {});
    return response.data as User[];
  } catch (error) {
    console.error('Failed to fetch users:', error);
  }
  return null;
};

// Get a specific user by user_id
export const getUserById = async (user_id: string): Promise<User | null> => {
  try {
    const response = await getData(`/users/${user_id}`, {});
    return response.data as User;
  } catch (error) {
    console.error(`Failed to fetch user with ID ${user_id}:`, error);
  }
  return null;
};

// Create a new user
export const createUser = async (user: CreateUserType): Promise<boolean> => {
  try {
    const response = await postData('/users', user);
    return response.success;
  } catch (error) {
    console.error('Failed to create user:', error);
    return false;
  }
  return false;
};

// Update a user by user_id
export const updateUser = async (user_id: string, user: User): Promise<User | null> => {
  try {
    const response = await putData(`/users/${user_id}`, user);
    return response.data as User;
  } catch (error) {
    console.error(`Failed to update user with ID ${user_id}:`, error);
  }
  return null;
};

// Soft delete a user by user_id
export const deleteUser = async (user_id: string): Promise<boolean> => {
  try {
    await deleteData(`/users/${user_id}`, {});
    return true;
  } catch (error) {
    console.error(`Failed to delete user with ID ${user_id}:`, error);
  }
  return false;
};

export const checkUserExists = async (email: string): Promise<boolean> => {
  try {

      const response = await getData(`/user-exists?email=${encodeURIComponent(email)}`);
      return response.data.exists;

  } catch (error) {
    //console.error('Error checking user existence:', error);
    return false;
  }
};
